import { FaEdit, FaTrash, FaExchangeAlt } from "react-icons/fa";

interface ManageOffersCardProps {
    id: number;
    vertical: string;
    category: string;
    offer_creator: string;
    // onEdit: () => void;
    onDelete: () => void;
    onMigrate: () => void;

}


export default function ManageOffersCard({
    id,
    vertical,
    category,
    offer_creator,
    // onEdit,
    onDelete,
    onMigrate
}: ManageOffersCardProps) {


    return (
        <div className="flex flex-col md:flex-row md:items-center justify-between bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-lg p-4 mb-4 shadow-md transition-shadow hover:shadow-lg">
            <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="font-medium">{category}</div>
                <div className="font-medium">{vertical}</div>
                <div className="text-sm text-gray-500 dark:text-gray-400">{offer_creator}</div>
            </div>
            <div className="flex gap-2 mt-2 md:mt-0">
                <button
                    onClick={onMigrate}
                    className="flex items-center gap-1 px-3 py-1 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition-colors"
                >
                    <FaExchangeAlt /> Migrate
                </button>
                {/* <button
                    onClick={onEdit}
                    className="flex items-center gap-1 px-3 py-1 rounded-lg bg-orange-500 text-white hover:bg-orange-600 transition-colors"
                >
                    <FaEdit /> Edit
                </button> */}
                <button
                    onClick={onDelete}
                    className="flex items-center gap-1 px-3 py-1 rounded-lg bg-red-500 text-white hover:bg-red-600 transition-colors"
                >
                    <FaTrash /> Delete
                </button>
            </div>
        </div>
    );
}
